export const getPdfFileUrl = (name: string): string => {
    return `${process.env.REACT_APP_BASE_URL}LocalDocuments/GetPdfFile/?name=${encodeURIComponent(name)}`;
};
